import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-request-password',
  templateUrl: './request-password.component.html',
  styleUrls: ['./request-password.component.css'],
})
export class RequestPasswordComponent implements OnInit {
  form: FormGroup;
  hash: string;
  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private toast: ToastrService
  ) {
    this.activatedRoute.params.subscribe((obs) => {
      this.hash = obs.hash;
    });
  }

  ngOnInit(): void {
    this.addFieldsInForm();
    this.form.get('password').valueChanges.subscribe((res) => {
      //console.log(res);
    });
  }

  addFieldsInForm() {
    this.form = new FormGroup({
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
      ]),
      'new-password': new FormControl('', [
        Validators.required,
        Validators.minLength(6),
      ]),
    });
  }

  resetPassword() {
    return this.authService
      .resetPassword(this.form.value, this.hash)
      .then((res) => {
        this.toast.success(res.message);
        this.form.reset();
      })
      .catch((err) => {
        this.toast.error(err.error.message);
      });
  }
}
